<template>
  <zg-module
    v-bind="moduleProps"
    class="zg-testimonial-section"
    full-width
  >
    <slot
      slot="sub-title"
      name="sub-title"
    />

    <zg-trustpilot
      v-if="trustpilotData"
      v-bind="trustpilotData"
      :class="['trustpilot', {
        'trustpilot--minimal': minimal
      }]"
    >
      <span
        class="score"
        v-html="trustpilotData.scoreTemplate"
      />
    </zg-trustpilot>

    <div
      v-if="disclaimer && !minimal"
      class="disclaimer"
    >
      {{ disclaimer }}
    </div>

    <div
      v-if="!minimal"
      class="testimonials"
    >
      <zg-testimonial
        v-for="(item, index) in testimonials"
        :key="index"
        :image="item.image"
        :author="item.author"
        :stars="item.stars"
        :text="item.content"
        :date="item.date"
        :background="cardBackground"
      />
    </div>

    <zg-flex
      v-if="readMoreLink && readMoreLink.url && readMoreLink.text"
      justify-content="center"
      class="show-more"
    >
      <zg-button-link
        :href="readMoreLink.url"
        :text="readMoreLink.text"
        :button-props="{
          size: 'large',
          icons: { right: 'arrow-forward' },
          fullWidthMobile: true
        }"
      />
    </zg-flex>
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgFlex from '../../layout/flex/ZgFlex'
  import ZgButtonLink from '../../ZgButtonLink/ZgButtonLink'
  import ZgTestimonial from '../../ZgTestimonial/ZgTestimonial.vue'
  import ZgTrustpilot from '../../ZgTrustpilot/ZgTrustpilot.vue'
  import ZgModule from '../ZgModule/ZgModule.vue'

  export default {
    name: 'ZgTestimonialSection',
    components: {
      ZgButtonLink,
      ZgFlex,
      ZgModule,
      ZgTestimonial,
      ZgTrustpilot
    },
    mixins: [module],
    props: {
      title: {
        type: String,
        required: false,
        default: null
      },
      testimonials: {
        type: Array,
        required: true,
        validator: (items) =>
          items.every(({ date, author, content }) => date && author && content)
      },
      trustpilotData: {
        type: Object,
        required: true,
        validator: ({ stars, scoreTemplate }) => stars && scoreTemplate
      },
      readMoreLink: {
        type: Object,
        required: false,
        default: () => {},
        validator: link => !link || (link.text && link.url)
      },
      size: {
        type: String,
        required: false,
        default: null
      },
      disclaimer: {
        type: String,
        required: false,
        default: null
      }
    },
    computed: {
      minimal () {
        return this.size === 'minimal'
      },
      align () {
        return this.minimal
          ? 'center'
          : 'left'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .trustpilot {
    gap: rem(4px);
    margin: 0 0 rem(18px);

    &--minimal {
      align-items: center;
      margin: 0;
    }

    .score {
      color: color(gray-500);
    }
  }

  .disclaimer {
    @include type-body-m;

    margin: 0 0 rem(24px);
  }

  .testimonials {
    display: flex;
    flex-direction: column;
    gap: rem(16px);

    @include mq(medium) {
      flex-flow: row wrap;
      gap: rem(24px);
    }

    & > div {
      flex-basis: 100%;

      @include mq(medium) {
        flex-basis: calc(100% / 3 - (#{rem(24px)} * 2 / 3));
      }
    }
  }

  .show-more {
    margin: rhythm(medium) 0 0;
  }
</style>
